import type { IBannerModel } from './Types';

export default (banners: Array<IBannerModel>) => {
  return banners.map((banner: IBannerModel) => {
    return {
      type: banner.type || '',
      style: banner.style || '',
    };
  });
};
